import * as types from '../actions/actionTypes';
import { newMapWith, updateableReducer } from './common';
import initialState from './initialState';
import { isUndefinedNullOrEmpty } from '../utils';

const createClone = jsonClone => {
    const { latestOperation, ...clone } = jsonClone;
    clone.latestOperationId = (!isUndefinedNullOrEmpty(latestOperation)) ? latestOperation.id : null;
    return clone;
};

const cloneReducerFactory = actionType => {
    switch (actionType) {
        case types.CLONES_UPDATED:
            return (stateValue, actionValue) => new Map(actionValue.map(jsonClone => [jsonClone.id, createClone(jsonClone)]));
        case types.CLONE_CREATION_UPDATED:
            return (stateValue, actionValue) => {
                const cloneId = actionValue.cloneId;
                const clone = {
                     ...createClone(actionValue.clone),
                    id: cloneId
                };
                return newMapWith(stateValue, cloneId, clone);
        };
        case types.CLONE_STATUS_UPDATED:
            return (stateValue, actionValue) => {
                const existingValue = stateValue.get(actionValue.id) || {};
                return newMapWith(stateValue, actionValue.id, { ...existingValue, status: actionValue.status });
            };
        case types.CLONE_DELETION_UPDATED:
            return (stateValue, actionValue) => {
                const existingValue = stateValue.get(actionValue.cloneId);
                if (isUndefinedNullOrEmpty(existingValue)) { return stateValue; };
                return newMapWith(stateValue, actionValue.cloneId, { ...existingValue, latestOperationId: actionValue.operationId });
            };

        default:
            return null;
    }
};

export default updateableReducer(cloneReducerFactory, initialState.clones);


// WEBPACK FOOTER //
// ./src/js/reducers/cloneReducer.js